"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getComponentDataAttributes = void 0;
var DATA_KEY = 'data-';
var getComponentDataAttributes = function getComponentDataAttributes(dataAttributes) {
  if (dataAttributes) {
    return Object.keys(dataAttributes).reduce(function (attributes, key) {
      var attributeValue = dataAttributes[key];
      var validKey = key.toLowerCase();
      if (validKey.startsWith(DATA_KEY)) {
        attributes[validKey] = attributeValue;
      } else {
        attributes["".concat(DATA_KEY).concat(validKey)] = attributeValue;
      }
      return attributes;
    }, {});
  }
  return {};
};
exports.getComponentDataAttributes = getComponentDataAttributes;